var _defs, _ellipse, _ellipse2, _polygon, _ellipse3, _polygon2, _ellipse4, _ellipse5, _ellipse6, _ellipse7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoucheEgoutDecouverte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bouche_d_\\xE9gouts",
    "data-name": "bouche d'\\xE9gouts",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.99 44.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afafaf;}.cls-2{fill:#ccc;}.cls-3{fill:#2d2d2d;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_68);}.cls-5{fill:#606060;}.cls-6{fill:#282828;}.cls-7{fill:none;stroke:#3d3d3d;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_68",
    x1: 100.28,
    y1: 10.31,
    x2: 100.28,
    y2: 38.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c1915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f0a09"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bouche d&amp;apos;\xE9gout d\xE9couverte") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 101.56,
    cy: 26.45,
    rx: 69.43,
    ry: 18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 101.56,
    cy: 24.45,
    rx: 69.43,
    ry: 18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "19.01 13.52 19.51 15.99 118.42 14.19 117.99 11.73 19.01 13.52"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 100.28,
    cy: 24.45,
    rx: 60.43,
    ry: 14.14
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.67 14.62 0.03 11.41 126.99 9.73 127.99 12.73 0.67 14.62"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 735.29,
    cy: 2100.8,
    rx: 63.65,
    ry: 10.29,
    transform: "translate(-697.64 -2077.75) rotate(-0.73)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 734.65,
    cy: 2097.59,
    rx: 63.65,
    ry: 10.29,
    transform: "translate(-697.6 -2077.76) rotate(-0.73)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 735.59,
    cy: 2097.45,
    rx: 2.68,
    ry: 0.31,
    transform: "matrix(1, -0.02, 0.02, 1, -712.16, -2072.38)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 734.28,
    cy: 2097,
    rx: 59.72,
    ry: 7.99,
    transform: "translate(-712.15 -2072.4) rotate(-1.13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoucheEgoutDecouverte);
export default __webpack_public_path__ + "static/media/bouche_egout_decouverte.aedcf91459eaafa9596b2a64d41d03b5.svg";
export { ForwardRef as ReactComponent };